import tokenStorage from '../tokenStorage';
import * as types from './actionTypes';
import { generateUserFromToken } from '../auth';

export function dispatchActionData(type, data) {
	return { type: type, data: data };
}

export function login(data) {
	return function (dispatch) {
		tokenStorage.saveToken(data);
		if (data) {
			const userData = generateUserFromToken(data);
			dispatch(dispatchActionData(types.LOGIN, userData));
		}
	};
}

export function logout(data) {
	return function (dispatch) {
		tokenStorage.clearToken();
		dispatch(dispatchActionData(types.LOGOUT, data));
	};
}
